import { Input } from "baseui/input";
import { LabelLarge, LabelMedium } from 'baseui/typography';
import { Block } from 'baseui/block';
import { IControlledCoolingOutletRelease } from './types'

// api
import { FormattedMessage } from 'react-intl';
import { VscPassFilled, VscCircleLarge } from 'react-icons/vsc';
import { OperatorPanelWrapper } from '../../../components/Layout';
import { themedUseStyletron } from "../../../../theme/customTheme";
import { Checkbox, STYLE_TYPE } from "baseui/checkbox";
import { FormControl } from "baseui/form-control";
import { useSetObjectValue } from "../../../../hooks/useSetObjectValue";




export const OperatorPanel = (props: IControlledCoolingOutletRelease) => {
    const [css, theme] = themedUseStyletron();

    const [oTRelease, setOTRelease] = useSetObjectValue(props.id, props.resourceGroupId, "oTRelease", props.oTRelease);
const onOTReleaseChanged = (e: any) => {
    if (e)
        setOTRelease(true);
    else
        setOTRelease(false);
}
const [eXTRelease, setEXTRelease] = useSetObjectValue(props.id, props.resourceGroupId, "eXTRelease", props.eXTRelease);
const onEXTReleaseChanged = (e: any) => {
    if (e)
    setEXTRelease(true);
    else
    setEXTRelease(false);
}

    return (
        <OperatorPanelWrapper
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                {props.release &&
                    <>
                        <VscPassFilled color={theme.appColors.aggregate.on} size={theme.sizing.scale800}></VscPassFilled>
                        <LabelLarge><FormattedMessage id="Devices.ON" defaultMessage="ON" /></LabelLarge>
                    </>
                }
                {!props.release &&
                    <>
                        <VscCircleLarge color={theme.appColors.aggregate.off}  size={theme.sizing.scale800}></VscCircleLarge>
                        <LabelLarge color={theme.appColors.aggregate.off}><FormattedMessage id="Devices.OFF" defaultMessage="OFF" /></LabelLarge>
                    </>
                }
                
                </>
            }
            additionalContent={
                <>
                <FormControl
                caption={<FormattedMessage id="Logics.TextOTRelease" defaultMessage="Activate the release via the outside temperature." />}>
                <Checkbox
                    checked={oTRelease}
                    checkmarkType={STYLE_TYPE.toggle_round}
                    onChange={(e: any) => { onOTReleaseChanged(e.target.checked) }}
                    disabled={false}>
                    {<FormattedMessage id="Logics.OTRelease" defaultMessage="Activate outside temperature release" />}
                </Checkbox>
            </FormControl>
            <FormControl
                caption={<FormattedMessage id="Logics.TextEXTRelease" defaultMessage="Activate the release via the external request." />}>
                <Checkbox
                    checked={eXTRelease}
                    checkmarkType={STYLE_TYPE.toggle_round}
                    onChange={(e: any) => { onEXTReleaseChanged(e.target.checked) }}
                    disabled={false}>
                    {<FormattedMessage id="Logics.EXTRelease" defaultMessage="Activate external request" />}
                </Checkbox>
            </FormControl>
            </>
            }
        >
        </OperatorPanelWrapper>

    )
}

